import { Provider, defaultTheme } from '@adobe/react-spectrum'

import { useEffect, useState } from 'react'

export default function SWC2() {
  const [color, setColor] = useState<'light' | 'dark' | undefined>(undefined)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://jspm.dev/@spectrum-web-components/bundle/elements.js'
    script.type = 'module'
    script.defer = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  useEffect(() => {
    const script = document.createElement('script')
    script.src =
      'https://cdn.substance3d.com/v2/files/public/a3d-viewer-latest.js'
    script.type = 'module'
    script.defer = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  const toggleColor = () => {
    const currentColor = color === 'light' ? 'dark' : 'light'
    setColor(currentColor)
  }

  return (
    <div style={{ width: '800px', margin: '0 auto' }}>
      <sp-theme
        scale="large"
        color="light"
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          backgroundColor: 'white',
        }}
      >
        <div
          style={{
            padding: '20px',
            display: 'flex',
            gap: '10px',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          Actual color : {color ?? 'N/A'}
          <sp-button onclick={toggleColor} variant="secondary">
            Toggle swc2 color
          </sp-button>
        </div>
      </sp-theme>

      <article>
        <h2>React Spectrum provider</h2>
        <Provider
          theme={defaultTheme}
          colorScheme={color}
          id="provider"
          UNSAFE_className={`flex flex-1 flex-col ${color === 'light' ? 'bg-white' : 'bg-black'}`}
          scale="medium"
        >
          <a3d-viewer clear-color="#77777880">
            <a3d-model src="https://cdn.substance3d.com/v2/files/public/BoomBox.glb"></a3d-model>
            <a3d-toolbar slot="tool-bar">
              <div slot="left">
                <a3d-button disabled>disabled</a3d-button>
              </div>
            </a3d-toolbar>
          </a3d-viewer>
        </Provider>
      </article>

      <article>
        <h2>sp-theme provider</h2>
        <sp-theme scale="large" color={color}>
          <a3d-viewer clear-color="#77777880">
            <a3d-model src="https://cdn.substance3d.com/v2/files/public/BoomBox.glb"></a3d-model>
            <a3d-toolbar slot="tool-bar">
              <div slot="left">
                <a3d-button disabled>disabled</a3d-button>
              </div>
            </a3d-toolbar>
          </a3d-viewer>
        </sp-theme>
      </article>

      <article>
        <h2>sp-theme provider in a React Spectrum provider</h2>
        <Provider
          theme={defaultTheme}
          colorScheme={color}
          id="provider"
          UNSAFE_className={`flex flex-1 flex-col ${color === 'light' ? 'bg-white' : 'bg-black'}`}
          scale="medium"
        >
          <sp-theme scale="large" color={color}>
            <a3d-viewer clear-color="#77777880">
              <a3d-model src="https://cdn.substance3d.com/v2/files/public/BoomBox.glb"></a3d-model>
              <a3d-toolbar slot="tool-bar">
                <div slot="left">
                  <a3d-button disabled>disabled</a3d-button>
                </div>
              </a3d-toolbar>
            </a3d-viewer>
          </sp-theme>
        </Provider>
      </article>

      <article>
        <h2>
          Viewer only (no provider - will react to browser's
          prefers-color-scheme media query)
        </h2>

        <a3d-viewer clear-color="#77777880">
          <a3d-model src="https://cdn.substance3d.com/v2/files/public/BoomBox.glb"></a3d-model>
          <a3d-toolbar slot="tool-bar">
            <div slot="left">
              <a3d-button disabled>disabled</a3d-button>
            </div>
          </a3d-toolbar>
        </a3d-viewer>
      </article>
    </div>
  )
}
